<template>
  <v-file-input v-bind="$attrs" v-model="fichero" :error-messages="mensajeError" @change="procesarFichero"></v-file-input>
</template>

<script>
export default {
  props: {
    bytesMaximo: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fichero: null,
      mensajeError: null,
    };
  },

  methods: {
    procesarFicheroSeleccionado (fileObject) {
        if (fileObject) {
            const reader = new FileReader();
            reader.onload = (e) => {
              if (this.bytesMaximo > 0 && e.total > this.bytesMaximo) {
                this.mensajeError = 'El tamaño del fichero excede el máximo permitido';
                this.$emit('error', this.mensajeError);
              } else {
                const ficheroComoDatosURL = e.target.result;
                this.mensajeError = null;
                this.$emit('input', ficheroComoDatosURL);
              }
            };
            reader.readAsDataURL(fileObject);
        } else {
          this.$emit('input', null);
        }
    },
    procesarFichero() {
      if (this.fichero != null)
        this.procesarFicheroSeleccionado (this.fichero);
      else {
        this.mensajeError = null;
        this.$emit('input', null);
      }
    },
  }
};
</script>

<style>
</style>